function getCropYearValidationIssues(cropYear = {}) {
  return Array.isArray(cropYear?.validation_issues)
    ? cropYear.validation_issues
    : [];
}

function getBlockingValidationIssues(cropYear = {}, scope = "ready") {
  const key =
    scope === "finalized" ? "blocking_for_finalized" : "blocking_for_ready";

  return getCropYearValidationIssues(cropYear).filter((issue) => issue?.[key]);
}

function getIssueRouteStep(issue = {}) {
  const step = issue?.ui_target?.step;

  if (step === "farm" || step === "field") return step;

  if (step === "field_operations") {
    return "field-operations";
  }

  if (step === "harvest") {
    return "harvest";
  }

  return "rotation";
}

function getIssueFieldName(issue = {}) {
  if (issue?.ui_target?.field) {
    return issue.ui_target.field;
  }

  if (typeof issue?.field_path === "string") {
    const parts = issue.field_path.split(".");
    return parts[parts.length - 1] || "";
  }

  return "";
}

function buildIssueSearch(issue = {}) {
  const params = new URLSearchParams();
  const field = getIssueFieldName(issue);
  const section = issue?.ui_target?.section;

  if (field) {
    params.set("issueField", field);
  }

  if (section) {
    params.set("issueSection", section);
  }

  if (typeof issue?.row_index === "number") {
    params.set("issueRow", String(issue.row_index));
  }

  if (typeof issue?.field_path === "string" && issue.field_path) {
    params.set("issuePath", issue.field_path);
  }

  const search = params.toString();
  return search ? `?${search}` : "";
}

export {
  buildIssueSearch,
  getBlockingValidationIssues,
  getCropYearValidationIssues,
  getIssueFieldName,
  getIssueRouteStep,
};
